import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {User} from '../../_models/index';
import {AlertService, AuthenticationService} from '../../_services';
import {AESEncryptDecryptService} from '../../_services/aesencrypt-decrypt.service';
import {Constants} from '../../constants/constants';
import {UtilsService} from '../../_services/utils.service';
import {OTPLoginService} from '../../_services/OTPLogin.service';

@Component({
  selector: 'app-logout-page',
  styleUrls: ['logout.component.scss'],
  templateUrl: 'logout.component.html'
})
export class LogoutComponent implements OnInit {
  Constants = Constants;
  logoutForm: FormGroup;
  loading = false;
  submitted = false;
  loggedOut  = false;
  currentUser: User;
  returnUrl: string;
  error = false;
  selectedRole: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private alertService: AlertService,
    private utilsService: UtilsService,
    private otpLoginService: OTPLoginService) {
        this.currentUser = this.utilsService.getCurrentUser();
        this.selectedRole = this.currentUser?.selectedRole;
  }

  ngOnInit() {
    this.logoutForm = this.formBuilder.group({
      password: ['', Validators.required]
    });
    setTimeout(() => {
      if (!this.loggedOut) {
        if (this.selectedRole === Constants.TABLE) {
          this.router.navigate(['/sidebar/order']);
        } else if (this.selectedRole === Constants.KIOSK) {
          this.router.navigate(['/kiosk']);
        }
      }
    }, 25000);
  }

  // convenience getter for easy access to paymentForm fields
  get f() {
    return this.logoutForm.controls;
  }

  onSubmit() {
    this.error = false;
    this.submitted = true;
    this.loading = true;
    // stop here if paymentForm is invalid
    if (this.logoutForm.invalid) {
      return;
    }

    // console.log(localStorage.getItem(this.currentUser.username));
    if (this.currentUser.orgSettings.accountType === Constants.CLOVER) {
      this.cloverAuthLogout();
    } else if (this.currentUser.orgSettings.accountType === Constants.SQUARE) {
      this.squareAuthLogout();
    }
  }

  private cloverAuthLogout() {
    let username = this.currentUser.username.split(' ')[0];
    if (this.selectedRole === 'Table') {
      username = 'table' + this.currentUser.orgSettings.uniqueOrgIdent;
    }
    this.authenticationService.login(username, this.f.password.value)
        .subscribe(
            () => this.doLogout(),
            () => this.tryOtpLogout());
  }

  private squareAuthLogout() {
    let username = this.currentUser.username.split(' ')[0];
    if (this.selectedRole === 'Table') {
      username = 'table' + this.currentUser.orgSettings.uniqueOrgIdent;
    }
    this.authenticationService.login(username, this.f.password.value)
        .subscribe(
            () => this.doLogout(),
            () => this.tryOtpLogout());
  }

  // If standard password fails, try the OTP code used to log in
  private tryOtpLogout() {
    this.otpLoginService.checkActivationCode(this.f.password.value).subscribe(
      user => {
        if (user?.user?.orgUuid === this.currentUser.orgUuid) {
          this.doLogout();
        } else {
          this.showAuthError();
        }
      },
      () => this.showAuthError()
    );
  }

  private doLogout() {
    this.authenticationService.logout();
    this.loggedOut = true;
    this.authenticationService.setUser('');
    this.router.navigate(['']);
  }

  private showAuthError() {
    this.error = true;
    this.loading = false;
  }
}
